import { pageProperties, report } from './utils/base';
import { init as initEvents } from './components/events';
import { reportProductImpressions, reportPromoImpressions } from './components/impressions';

/**
 * @typedef {InstanceType<typeof import('widgets/toolbox/RefElement').RefElement>} refElement
 */
/**
 * @description clientGTM
 * @module clientGTM
 * @category widgets
 * @subcategory int_gtm
 */

declare global {
    interface Window {
        gtmDelayedEvent?: unknown;
    }

    interface IProductGtmInfo {
        id: string;
        name: string;
        category: string;
        quantity: number;
        price: string;
        position?: string;
    }
}

/**
 * @description Init GTM callback
 */
function init() {
    if (pageProperties.currentCurrency === '') {
        pageProperties.currentCurrency = window?.gtmUserData?.currency;
    }

    initEvents();
    reportProductImpressions();

    if (window.gtmDelayedEvent) {
        report(window.gtmDelayedEvent);
        delete window.gtmDelayedEvent;
    }

    reportPromoImpressions();
}

if (window.dataLayer) {
    if (document.readyState === 'loading') {
        /**
         * @description Init gtm once dom content loaded
         * @listens dom:DOMContentLoaded
         */
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                init();
            }, 0);
        }, { once: true });
    } else {
        init();
    }
}
